import React from "react";

import {
  FaListUl,
} from "react-icons/fa";

function getMobileLabel(
  sections,
  section,
  currentIndex
) {
  if (section.id === "intro") {
    return section.label;
  }

  if (section.id === "faq") {
    return section.label;
  }

  const sectionNumber = sections
    .slice(0, currentIndex + 1)
    .filter(
      (item) =>
        item.id !== "intro" &&
        item.id !== "faq"
    ).length;

  return `${sectionNumber}. ${section.label}`;
}

export default function TutorialMobileMenu({
  sections = [],
  activeSectionId,
  onSelect,
}) {
  return (
    <div className="sticky top-[160px] z-30 lg:hidden">
      <div className="rounded-2xl border border-slate-200 bg-white/95 p-3 shadow-lg backdrop-blur dark:border-slate-700 dark:bg-slate-900/95">
        <label
          htmlFor="tutorial-mobile-navigation"
          className="mb-2 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.14em] text-slate-500 dark:text-slate-400"
        >
          <FaListUl />
          Aller à une section
        </label>

        <select
          id="tutorial-mobile-navigation"
          value={
            activeSectionId || ""
          }
          onChange={(event) =>
            onSelect(
              event.target.value
            )
          }
          className="h-12 w-full rounded-xl border border-slate-200 bg-slate-50 px-4 text-sm font-semibold text-slate-800 outline-none focus:border-violet-400 focus:ring-4 focus:ring-violet-100 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-100 dark:focus:ring-violet-950"
        >
          {sections.map(
            (section, index) => (
              <option
                key={section.id}
                value={section.id}
              >
                {getMobileLabel(
                  sections,
                  section,
                  index
                )}
              </option>
            )
          )}
        </select>
      </div>
    </div>
  );
}